import axios from 'axios';
import _ from 'lodash';
import useSessionStore from '@/Stores/useSessionStore';
import { PHASE_STATUS } from '@/Utils/vice-constants';

const BASE_URL = '/api/session/phase';

// const SESSION_PHASES_URL = '/api/session-status';
const sessionStore = useSessionStore();
class PhaseService {
  // wrapper functions
  static async startPhase({ title }) {
    await this.#setPhase({ title, status: PHASE_STATUS.STARTED });
    await this.#setPhaseState(PHASE_STATUS.STARTED);
  }

  static async endPhase({ backToPreviousPhase }) {
    await this.#setPhaseState(PHASE_STATUS.ENDED, backToPreviousPhase);
  }

  static async pausePhase() {
    await this.#setPhaseState(PHASE_STATUS.PAUSED);
  }

  static async resumePhase() {
    await this.#setPhaseState(PHASE_STATUS.RESUMED);
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  static async #setPhase({ title, status }) {
    try {
      const res = await axios.post(
        `${BASE_URL}/set`,
        {
          uuid: sessionStore.sessionUniqueId,
          phase: title.toLowerCase(),
          state: status,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   *
   * @returns
   * @param request
   */
  static async lateEntryRequest(request) {
    try {
      const res = await axios.post(`${BASE_URL}/late-entry-accepts`, request, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  static async #setPhaseState(status, backToPreviousPhase = false) {
    try {
      const res = await axios.post(
        `${BASE_URL}/state/set`,
        {
          uuid: sessionStore.sessionUniqueId,
          state: status,
          backToPreviousPhase,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  // static async update({ id, title, status, timestamp }) {
  //   try {
  //     const res = await axios.post(SESSION_PHASES_URL, {
  //       session_uuid: id,
  //       phase_name: title.toLowerCase(),
  //       type: status,
  //       timestamp,
  //     });
  //     return res.data;
  //   } catch (error) {
  //     throw error.response;
  //   }
  // }

  static async resetPhasesData() {
    try {
      const res = await axios.post(`${BASE_URL}/reset/all`, {
        uuid: sessionStore.sessionUniqueId,
      });
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  static tidyPhaseTimes(phasesData) {
    const phasesDuration = {};

    phasesDuration[phasesData.current.name] = phasesData.current.statistics.duration;

    // if the phase is started or resumed, add the time passed since the last timestamp
    if (
      phasesData.current.state == PHASE_STATUS.STARTED ||
      phasesData.current.state == PHASE_STATUS.RESUMED
    ) {
      const timePassed = Date.now() / 1000 - phasesData.current.statistics.lastTimestamp;
      phasesDuration[phasesData.current.name] += timePassed;
    }

    // update the current phase duration in the store
    const storedCurrentPhase = _.find(
      sessionStore.phases,
      (ph) => ph.title.toLowerCase() == phasesData.current.name,
    );
    storedCurrentPhase.duration = phasesDuration[phasesData.current.name] * 1000;

    // update the previous phases durations
    phasesData.previous.forEach((_phase) => {
      const phase = JSON.parse(_phase).phase;
      phasesDuration[phase.name] = phase.statistics.duration;

      const storePhase = _.find(sessionStore.phases, (ph) => ph.title.toLowerCase() == phase.name);
      if (storePhase) {
        storePhase.duration = phase.statistics.duration * 1000;
      }
    });

    phasesDuration.current = phasesData.current.name;
    phasesDuration.status = phasesData.current.state;

    return phasesDuration;
  }

  static async getTimes(id) {
    try {
      const res = await axios.get(`${BASE_URL}/current/${id}`);
      return this.tidyPhaseTimes(res.data);
    } catch (error) {
      throw error.response;
    }
  }
}

export default PhaseService;
